<template>
  <div class="mt-4">
    <div v-for="(campaign, index) in campaigns" :key="`punch-card-campaign-${index}`"
      :id="`punch-card-campaign-${index}`" :class="{ 'mb-3': index < campaigns.length - 1 }">
      <PunchCardTemplate :campaign="campaign" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PunchCardTemplate from "./PunchCardTemplate";

export default {
  components: { PunchCardTemplate },
  computed: {
    ...mapState("punchCard", ["campaigns"])
  }
}
</script>
